const state = {
  currentGlobalConfigId: '',
  currentClientConfigNumber: '',
  duplicateGlobalConfigIdReference: '',
  currentClientId: '',
  currentConfiguration: {}
}

function initialState() {
  return {
    currentGlobalConfigId: '',
    duplicateGlobalConfigIdReference: '',
    currentClientConfigNumber: '',
    currentClientId: '',
    currentConfiguration: {}
  }
}

// getters
const getters = {}

// actions
const actions = {
  setCurrentGlobalConfigId_Store({
    commit,
    state
  }, globalConfigId) {
    commit('mutateCurrentGlobalConfigId', globalConfigId)
  },
  setCurrentClientConfigNumber_Store({
    commit,
    state
  }, configNumber) {
    commit('mutateCurrentClientConfigNumber', configNumber)
  },
  setDuplicateGlobalConfigIdReference_Store({
    commit,
    state
  }, globalConfigId) {
    commit('mutateDuplicateGlobalConfigIdReferenceReference', globalConfigId)
  },
  setCurrentClientId_Store({
    commit,
    state
  }, clientId) {
    commit('mutateCurrentClientId', clientId)
  },
  setCurrentConfiguration_Store({
    commit,
    state
  }, config) {
    commit('mutateCurrentConfiguration', config)
  },
  resetToInitialState({
    commit,
    state
  }) {
    commit('reset')
  }
}

// mutations
const mutations = {
  mutateCurrentGlobalConfigId(state, globalConfigId) {
    state.currentGlobalConfigId = globalConfigId
  },
  mutateCurrentClientConfigNumber(state, configNumber) {
    state.currentClientConfigNumber = configNumber
  },
  mutateDuplicateGlobalConfigIdReferenceReference(state, globalConfigId) {
    state.duplicateGlobalConfigIdReference = globalConfigId
  },
  mutateCurrentClientId(state, clientId) {
    state.currentClientId = clientId
  },
  mutateCurrentConfiguration(state, config) {
    state.currentConfiguration = config
  },
  reset(state) {
    // acquire initial state
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
